import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { API_CONST } from "@core/constants/api.constants";
import { environment } from "@environments/environment";

export interface Notification {
  id: string;
  createdAt: Date;
  updatedAt: Date;
  entityType: string;
  entityId: string;
  notificationType: string;
  recipientId: string;
  recipientType: string;
  channel: string;
  sentAt: Date;
  metadata?: Record<string, any>;
  readAt: Date | null;
  recipient?: {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    phoneCode?: string;
    phoneNumber?: string;
    createdAt: Date;
    updatedAt: Date;
    avatar?: string | null;
  };
  // Optional fallback for projectId (though it's typically in metadata)
  projectId?: string;
}

export interface NotificationQuery {
  businessId?: string;
  read?: boolean;
  limit?: number;
  offset?: number;
}

@Injectable({
  providedIn: "root",
})
export class NotificationService {
  readonly apiUrl = environment.apiUrl;
  readonly http = inject(HttpClient);

  getNotifications(query?: NotificationQuery) {
    return this.http.get<Notification[]>(`${this.apiUrl}${API_CONST.NOTIFICATION.GET_ALL}`, { params: { ...query } });
  }

  getUnreadCount(businessId: string) {
    return this.http.get<{ count: number }>(`${this.apiUrl}${API_CONST.NOTIFICATION.GET_UNREAD_COUNT}`, {
      params: { businessId },
    });
  }

  markAsRead(notificationId: string) {
    return this.http.patch<Notification>(`${this.apiUrl}${API_CONST.NOTIFICATION.MARK_AS_READ.replace(":id", notificationId)}`, {});
  }

  markAllAsRead(businessId: string) {
    return this.http.patch<{ count: number }>(`${this.apiUrl}${API_CONST.NOTIFICATION.MARK_ALL_READ}`, {}, { params: { businessId } });
  }
}

